import React from "react";
import { CheckCircle2, MinusCircle, XCircle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const GROUPS: [string, string, any, string][] = [
  ["approved", "Approved", CheckCircle2, "text-[#15803D]"],
  ["skipped", "Skipped", MinusCircle, "text-[#B45309]"],
  ["failed", "Could not be approved", XCircle, "text-[#B91C1C]"],
];

export function BulkSummary({ job, onClose }: { job: any; onClose: () => void }) {
  const results: any[] = job?.results || [];
  return (
    <Dialog open={!!job} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg rounded-2xl" data-testid="dow-bulk-summary">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Approval summary</DialogTitle>
          <DialogDescription className="text-[15px]" data-testid="dow-bulk-summary-counts">
            {job?.approved} approved · {job?.skipped} skipped{job?.failed ? ` · ${job.failed} could not be approved` : ""} of {job?.total} selected.
            {job?.approved ? " Certificates are grouped by charter for the Compliance Coordinators." : ""}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[55vh] space-y-4 overflow-y-auto pr-1">
          {GROUPS.map(([key, label, Icon, tone]) => {
            const rows = results.filter((r) => r.status === key).sort((a, b) => a.name.localeCompare(b.name));
            if (!rows.length) return null;
            return (
              <div key={key} data-testid={`dow-bulk-summary-${key}`}>
                <p className={`mb-1.5 flex items-center gap-2 text-sm font-bold ${tone}`}><Icon className="h-4 w-4" /> {label} ({rows.length})</p>
                <ul className="divide-y divide-slate-100 rounded-xl border border-slate-200">
                  {rows.map((r) => (
                    <li key={r.id} className="flex flex-wrap items-baseline justify-between gap-x-3 px-3 py-2 text-sm" data-testid={`dow-bulk-row-${r.id}`}>
                      <span className="font-semibold text-[#1A2536]">{r.name}<span className="ml-2 font-normal text-[#64748B]">{r.location}</span></span>
                      {r.reason && <span className="text-xs text-[#64748B]">{r.reason}</span>}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <div className="flex justify-end"><button className="btn-primary btn-sm" onClick={onClose} data-testid="dow-bulk-summary-close">Done</button></div>
      </DialogContent>
    </Dialog>
  );
}
